import type { RouteRecordRaw } from 'vue-router'
import {
  feedbackRouteCandidates,
  toAnyPermission,
} from '@/config/businessRoutePermissions'
import { legacyTenantRedirect, maybeRouteName } from './tenantScoped'

const createFeedbackChildren = (withNames: boolean): RouteRecordRaw[] => [
  {
    path: 'items',
    ...maybeRouteName(withNames, 'feedback-items'),
    component: () => import('@/views/feedback/FeedbackList.vue'),
    meta: { title: '反馈列表', permission: 'feedback:item:view' }
  },
  {
    path: 'items/:id',
    ...maybeRouteName(withNames, 'feedback-detail'),
    component: () => import('@/views/feedback/FeedbackDetail.vue'),
    meta: { title: '反馈详情', permission: 'feedback:item:view' }
  },
  {
    path: 'apps',
    ...maybeRouteName(withNames, 'feedback-apps'),
    component: () => import('@/views/feedback/FeedbackAppList.vue'),
    meta: { title: '接入应用', permission: 'feedback:app:view' }
  },
  {
    path: 'apps/:appId/product-bindings',
    ...maybeRouteName(withNames, 'feedback-product-bindings'),
    component: () => import('@/views/feedback/FeedbackProductBinding.vue'),
    meta: { title: '产品绑定规则', permission: 'feedback:app:view' }
  }
]

const createFeedbackRoute = (path: string, defaultRouteBasePath: string, withNames: boolean): RouteRecordRaw => ({
  path,
  component: () => import('@/views/feedback/FeedbackLayout.vue'),
  ...(withNames ? {} : { beforeEnter: legacyTenantRedirect }),
  meta: {
    permission: toAnyPermission(feedbackRouteCandidates),
    defaultRouteBasePath,
    defaultRouteCandidates: feedbackRouteCandidates,
    ...(!withNames ? { legacyTenantRedirect: true } : {}),
  },
  children: createFeedbackChildren(withNames)
})

const feedbackRoutes: RouteRecordRaw[] = [
  createFeedbackRoute('t/:tenantCode/feedback', '/t/:tenantCode/feedback', true),
  createFeedbackRoute('feedback', '/feedback', false),
]

export default feedbackRoutes
